'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hashSigns = require('./hashSigns');

var _hashSigns2 = _interopRequireDefault(_hashSigns);

var _hashtagAlpha = require('./hashtagAlpha');

var _hashtagAlpha2 = _interopRequireDefault(_hashtagAlpha);

var _hashtagAlphaNumeric = require('./hashtagAlphaNumeric');

var _hashtagAlphaNumeric2 = _interopRequireDefault(_hashtagAlphaNumeric);

var _hashtagBoundary = require('./hashtagBoundary');

var _hashtagBoundary2 = _interopRequireDefault(_hashtagBoundary);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validHashtag = (0, _regexSupplant2.default)(/(#{hashtagBoundary})(#{hashSigns})(?!\uFE0F|\u20E3)(#{hashtagAlphaNumeric}*#{hashtagAlpha}#{hashtagAlphaNumeric}*)/gi, { hashtagBoundary: _hashtagBoundary2.default, hashSigns: _hashSigns2.default, hashtagAlphaNumeric: _hashtagAlphaNumeric2.default, hashtagAlpha: _hashtagAlpha2.default }); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validHashtag;
module.exports = exports['default'];